import { guardNever } from "@hex/common";

import {
  ContextWorkbenchFile,
  ContextWorkbenchFileData,
} from "../contextWorkbenchFile";
import { ContextWorkbenchState } from "../contextWorkbenchState";

export type InitEditorFilePayload = Omit<ContextWorkbenchFile, "id">;

export function initEditorFile(
  state: ContextWorkbenchState,
  payload: InitEditorFilePayload,
): void {
  if (payload.type === ContextWorkbenchFile.Type.Rule) {
    state.editor.files.magicRules.data = payload.data;
    state.editor.files.magicRules.loading = payload.loading;
    state.editor.files.magicRules.error = payload.error;
  } else {
    guardNever(payload.type, payload.type);
  }
}

export type UpdateEditorFileContentsPayload = Pick<
  ContextWorkbenchFile,
  "type" | "id"
> & {
  contents: ContextWorkbenchFileData["contents"];
};

export function updateEditorFileContents(
  state: ContextWorkbenchState,
  payload: UpdateEditorFileContentsPayload,
): void {
  if (payload.type === ContextWorkbenchFile.Type.Rule) {
    if (state.editor.files.magicRules.data == null) return;
    if (state.editor.files.magicRules.id !== payload.id) return;
    state.editor.files.magicRules.data.contents = payload.contents;
  } else {
    guardNever(payload.type, payload.type);
  }
}
